import React from "react";
import { FiX } from "react-icons/fi";
import { payoutUi } from "./payoutDesignSystem";

export type PayoutFilterChip = {
  label: string;
  value: string;
  onRemove: () => void;
  hidden?: boolean;
};

const defaultFilterValues = new Set([
  "",
  "All",
  "All Status",
  "All Accounts",
  "All Categories",
  "All Methods",
  "All Users",
  "All Amounts",
  "All Roles",
  "All Access Levels",
  "All Payout Methods",
  "All Types",
  "System & Custom",
  "Date (all)",
  "Date (Today)",
]);

const isDefaultFilter = (value: string) => defaultFilterValues.has(value);

function PayoutFilterChips({
  chips,
  className = "",
}: {
  chips: PayoutFilterChip[];
  className?: string;
  onClearAll?: () => void;
}) {
  const visibleChips = chips.filter(
    (chip) => !chip.hidden && !isDefaultFilter(chip.value.trim()),
  );

  if (!visibleChips.length) return null;

  return (
    <div className={"flex flex-wrap items-center gap-2 " + className}>
      {visibleChips.map((chip) => (
        <span
          key={`${chip.label}-${chip.value}`}
          className={payoutUi.chip.item}
        >
          <span className={payoutUi.chip.text}>{chip.value}</span>
          <button
            type="button"
            aria-label={`Remove ${chip.label} filter`}
            onClick={chip.onRemove}
            className={payoutUi.chip.remove}
          >
            <FiX className="h-3.5 w-3.5 stroke-[3]" />
          </button>
        </span>
      ))}
    </div>
  );
}

export default PayoutFilterChips;
